var map = {
	"./slider1.jpg": 3348,
	"./slider2.jpg": 9482,
	"./slider3.jpeg": 276,
	"./slider3.jpg": 637,
	"./slider4.jpg": 8681,
	"./slider5.jpg": 7062,
	"./slider6.jpg": 7524,
	"./sliderLuli.jpg": 1205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5531;